// @ts-nocheck
/* eslint-disable */

const initYaGoals = () => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('source')) {
        if (
            urlParams.get('source') == 'dzen.ru' ||
            urlParams.get('source') == 'win.mail.ru' ||
            urlParams.get('source') == 'news.mail.ru' ||
            urlParams.get('source') == 'mail.ru' ||

            urlParams.get('source') == 'avito.ru' ||
            urlParams.get('source') == 'm.avito.ru' ||

            urlParams.get('source') == 'ok.ru' ||
            urlParams.get('source') == 'vk.com' ||

            urlParams.get('source') == 'mail.yandex.ru' ||
            urlParams.get('source') == 'maps.yandex.ru' ||
            urlParams.get('source') == 'yandex.ru'
        ) {
            if (!Cookies.get('source_goal')) {
                Cookies.set('source_goal', 'set', {expires: 7});
                ym(97176230, 'reachGoal', 'source_ok');
            }
        }
    }

    const settings = {
        need     : 30,
        checkTime: 10,
        IDmetrika: 97176230 // Сюда вписываем ИД Счетчика Яндекс Метрики
    };

    const metricsFn = function() {

        console.log(ActiveScore.timer);

        console.log(ActiveScore.need);

        const c1 = this.getCookie(this.cookieName);


        console.log(c1);

        if (ActiveScore.timer >= ActiveScore.need) {

            console.log('событие отправилось');

            ym(settings.IDmetrika, 'reachGoal', this.cookieName.slice(0, -3));
        }
    };

    var ActiveScore = {
        need        : settings.need,
        checkTime   : settings.checkTime,
        loop        : false,
        counter     : 0,
        cookieName  : '60sec_ap',
        sendFn      : null,
        parts       : 0,
        active_parts: 0,
        timer       : 0,
        events      : ['touchmove', 'blur', 'focus', 'focusin', 'focusout', 'load', 'resize', 'scroll', 'unload', 'click', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'mouseover', 'mouseout', 'mouseenter', 'mouseleave', 'change', 'select', 'submit', 'keydown', 'keypress', 'keyup', 'error'],

        setEvents() {
            for (let index = 0; index < this.events.length; index++) {
                const eName = this.events[index];

                window.addEventListener(eName, (e) => {
                    if (e.isTrusted && ActiveScore.period.events == false) {
                        ActiveScore.period.events = true;
                    }
                });
            }
        },

        period: {
            start : 0,
            end   : 0,
            events: false
        },

        init(fn) {
            this.calcParts();
            this.setEvents();
            this.setStartCounter();
            if (this.checkCookie()) {
                this.sendFn = fn;
                this.start();
            }
        },

        readLastCookie() {
            const absurdlyLarge = 100000;

            for (let i = 1; i < absurdlyLarge; i++) {
                const cookie = this.getCookie(`${i * this.need}sec_ap`);

                if (cookie != this.parts * this.parts) {
                    return {i,
                        cookie};
                }
            }

            return {i     : 1,
                cookie: 0};
        },

        setStartCounter() {
            const lastCookie = this.readLastCookie();

            this.counter = lastCookie.i - 1;
            this.active_parts = Number(lastCookie.cookie);
            this.cookieName = `${(this.counter + 1) * this.need}sec_ap`;
        },

        calcParts() {
            this.parts = Math.ceil(this.need / this.checkTime);
        },

        setPeriod() {
            this.period.start = this.microtime();
            this.period.end = this.period.start + this.checkTime;
            this.period.events = false;
        },

        microtime() {
            const now = new Date().getTime() / 1000;
            const s = parseInt(now);

            return s;
        },

        start() {
            this.setPeriod();
            this.runPeriod();
        },

        timeoutId: null,

        checkPeriod() {
            if (this.period.events == true) {
                this.active_parts = this.active_parts + 1;
                // console.log('В этой секции были действия');
            } else {
                // console.log('В этой секции НЕБЫЛО действия');
            }
            this.timer = this.active_parts * this.checkTime;

            console.log(`${this.active_parts} / ${this.parts} [${this.timer}]`);

            if (this.checkSecs()) {
            } else {
                this.start();
            }
            this.setCookie(this.cookieName, this.active_parts);
        },

        checkSecs() {
            if (this.timer >= this.need) {
                this.send();
                if (this.loop == true) {
                    this.counter++;
                    this.timer = 0;
                    this.active_parts = 0;
                    this.cookieName = `${(this.counter + 1) * this.need}sec_ap`;

                    return false;
                }

                // console.log('Завершили проверку активности');
                return true;
            }

            return false;
        },

        timeoutFn() {
            ActiveScore.checkPeriod();
        },

        runPeriod() {
            this.timeoutId = setTimeout(this.timeoutFn, this.checkTime * 1000);
        },

        send() {
            if (this.getCookie(this.cookieName) == this.parts * this.parts) {
                this.setStartCounter();
            } else {
                this.setCookie(this.cookieName, this.active_parts * this.active_parts);
            }
            this.sendFn();
        },

        checkCookie() {
            let c = this.getCookie(this.cookieName);

            if (c == null) {
                return true;
            }
            if (c == '') {
                return true;
            }
            c = parseInt(c);
            if (c >= this.parts) {
                // console.log('Скрипт даже не запустился...');
                if (this.loop == true) {
                    return true;
                }

                return false;
            }
            this.active_parts = c;

            return true;
        },

        setCookie(name, value, days) {
            let expires = '';

            if (days) {
                const date = new Date();

                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = `; expires=${date.toUTCString()}`;
            }
            document.cookie = `${name}=${value || ''}${expires}; path=/`;
        },

        getCookie(name) {
            const nameEQ = `${name}=`;
            const ca = document.cookie.split(';');

            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];

                while (c.charAt(0) == ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) == 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }

            return null;
        },

        eraseCookie(name) {
            document.cookie =
                `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        }
    };

    ActiveScore.init(metricsFn);
};

export default initYaGoals;
/* eslint-enable */
